import { Column, EmptyState } from "@hightouch/htui";
import { MediaDetailHeader } from "src/components/media-detail";

type EntityNotFoundProps = { heading: string };

export const EntityNotFound = ({ heading }: EntityNotFoundProps) => (
  <Column gap={6}>
    <MediaDetailHeader title={heading} />
    <EmptyState
      variant="minimal"
      title={`${heading} not found`}
      message="It has no data for the selected date range."
    />
  </Column>
);
